import { style } from '@vanilla-extract/css'

const section = style({
  background: 'linear-gradient(180.01deg, #E5E8EB 40.8%, #F2F1EF 99.99%)',
})

const image = style({
  borderRadius: '42% / 32%',
  aspectRatio: '392 / 516',
})

const text = style({
  fontSize: '15px',
  lineHeight: '1.5',
})

const mazzo = style({
  position: 'relative',
  backgroundColor: 'white',
  borderRadius: '24px',
  marginTop: '-8px',
})

const dialogButton = style({
  position: 'absolute',
  top: '49%',
  left: '58%',
  wordBreak: 'keep-all',
  padding: '12px 16px',
  borderRadius: '20px',
  backgroundColor: 'white',
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  boxShadow: '0px 4px 8px 0px #5B5B5B29',
  cursor: 'pointer',
})

const dialogDescription = style({
  fontSize: '15px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  whiteSpace: 'pre-wrap',
  padding: '0 24px',
})

const bubble = style({
  position: 'absolute',
  width: '18px',
  height: '13px',
  top: '-10px',
})

const mazzoLine = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '16px',
  fontWeight: '700',
  lineHeight: '1.5',
  textAlign: 'center',
})

const mazzoPrice = style({
  color: '#7D7D7D',
  fontSize: '15px',
  lineHeight: '1.5',
  textDecoration: 'line-through',
})

const mazzoLabel = style({
  fontSize: '12px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: 'white',
  letterSpacing: '0.02em',
  backgroundColor: '#F43E3B',
  padding: '2px 4px',
  borderRadius: '4px',
})

export const styles = {
  section,
  image,
  text,
  mazzo,
  dialogButton,
  dialogDescription,
  bubble,
  mazzoLine,
  mazzoPrice,
  mazzoLabel,
}
